import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { DMSIDS } from "models";

import type { DealerDMSWinCarConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type WincarConfig = Pick<DealerDMSWinCarConfig, "dms_lease_customer_ids" | "client_id" | "audience" | "client_secret" | "api_base_url">;

type WincarConfigSectionProps = {
  dmsId: DMSIDS;
};

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const WincarConfigSection = ({ dmsId }: WincarConfigSectionProps) => {
  const { t } = useTranslation();

  const isWincarApi = [DMSIDS.WINCAR_API_EVENTS, DMSIDS.WINCAR_API_V2_EVENTS, DMSIDS.WINCAR_V1_WB, DMSIDS.WINCAR_V2_WB].includes(dmsId);

  return (
    <Grid columns="equal">
      <GridColumn>
        <Form.Field>
          <label>{t("v8_dms_lease_customer_id", "DMS Lease Customer ID")} </label>
          <FormHelper.Field.Input name="wincar_config.dms_lease_customer_ids" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      {isWincarApi && (
        <>
          <GridColumn>
            <Form.Field>
              <label>{t("v8_client_id", "Client ID")} </label>
              <FormHelper.Field.Input name="wincar_config.client_id" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_audience", "Audience")} </label>
              <FormHelper.Field.Input name="wincar_config.audience" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_client_secret", "Client Secret")} </label>
              <FormHelper.Field.Input name="wincar_config.client_secret" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>

          <GridColumn>
            <Form.Field>
              <label>{t("v8_api_base_url", "API Base URL")} </label>
              <FormHelper.Field.Input name="wincar_config.api_base_url" inputProps={{ fluid: true }} />
            </Form.Field>
          </GridColumn>
        </>
      )}
    </Grid>
  );
};
